export const SPECIALTY = {
  CVS_TITLE: 'CVS Specialty',
  FLOWNAME_DEMO_LOOKUP: 'DEMO_LOOKUP',
  FLOWNAME_QR: 'QR',
  LOB: 'SPECIALTY',
  GUEST_SOURCE: 'SPL_ONE_TIME_AUTH',
  RX_LABEL_SOURCE: '', // add when available
  LogoImage: '/Specialty_Logo.svg',
  AltText: 'CVS Specialty',
  FAQ_URL: '/faq.html',
  links: [],
  firstRowLinks: [],
  secondRowLinks: [],
  footerDataCopyRightText: `©${new Date().getFullYear()} CVS Specialty, Inc. All rights reserved.`,
  createAccountUrl: '/register',
  loginURL: '/account-login/look-up',
  customerCareNumber: '1-855-264-3239',
  mfaTenantInfo: {
    tenantType: 'specialty',
    integrationFunction: 'registration',
    integrationType: 'guest_registration'
  },
  alreadyExistAccountDescription: 'Sign in to your CVS Specialty account with your previous email.',
  privacyURL: '/privacy-policy.html'
};

export const CAREMARK = {
  CVS_TITLE: 'CVS Caremark',
  FLOWNAME_DEMO_LOOKUP: 'DEMO_LOOKUP',
  FLOWNAME_QR: 'QR',
  LOB: 'CAREMARK',
  GUEST_SOURCE: 'CMK_ONE_TIME_AUTH',
  RX_LABEL_SOURCE: '', // add when available
  LogoImage: '/account-lookup/Caremark_Logo.svg',
  AltText: 'CVS Caremark',
  FAQ_URL: '/wps/PA_FAST/HelpCenterProxy/',
  links: [{ name: 'Help center', link: '/wps/PA_FAST/HelpCenterProxy/#/' }],
  firstRowLinks: [
    { Label: 'About CVS Caremark', URL: '/about-us.html' },
    { Label: 'Contact', URL: '/about-us/contact-us.html' }
  ],
  secondRowLinks: [
    { Label: 'Terms and Conditions', URL: '/pharmacy/benefits/public/terms-conditions' },
    { Label: 'Privacy Policy', URL: '/pharmacy/benefits/public/privacy-policy' },
    { Label: 'Accessibility', URL: '/pharmacy/benefits/public/accessibility' },
    { Label: 'Member Rights & Responsbilites', URL: '/pharmacy/benefits/public/member-rights' },
    {
      Label: 'Vulnerability Disclosure Program',
      URL: 'https://www.cvshealth.com/vulnerability-disclosure-program.html'
    }
  ],
  footerDataCopyRightText: `Copyright © ${new Date().getFullYear()} CVS Caremark. All rights reserved`,
  createAccountUrl: '/register/create-account',
  loginURL: '/digital-fast/caremark-login-web/#/login',
  customerCareNumber: '1-800-552-8159',
  mfaTenantInfo: {
    tenantType: 'caremark',
    integrationFunction: 'registration',
    integrationType: 'pbm_user'
  },
  alreadyExistAccountDescription: 'Sign in to your CVS Caremark account with one of these usernames.',
  privacyURL: '/pharmacy/benefits/public/privacy-policy'
};

export const RETAIL = {
  CVS_TITLE: 'CVS Pharmacy',
  LogoImage: '/heart.svg',
  LOB: '',
  GUEST_SOURCE: 'RETAIL_ONE_TIME_AUTH',
  RX_LABEL_SOURCE: 'RETAIL_IMA_RX_LABEL',
  AltText: 'CVS',
  FAQ_URL: '/retail/help/help_contact_us',
  links: [],
  firstRowLinks: [],
  secondRowLinks: [],
  footerDataCopyRightText: '',
  createAccountUrl: '/create-account',
  loginURL: '/account-login/look-up',
  customerCareNumber: '1-888-607-4287',
  mfaTenantInfo: {
    tenantType: 'cvs',
    integrationFunction: 'h4life',
    integrationType: 'rxtie'
  },
  alreadyExistAccountDescription: '',
  privacyURL: '/retail/help/privacy_policy'
};
